import template from './report_department_growth.html';
import * as Utils from '../../lib/savanna_utils.js';
import tr from '../../lib/default-translator.js';

class ReportDepartmentGrowthViewModel
{
	constructor (page)
	{
		this.page = page;
		this.loader = ko.observable(false);

		this.date_start = ko.observable(),
		this.date_end = ko.observable()
		this.total_employed_in_company = ko.observable(0);
		this.total_resigned_in_company = ko.observable(0);
		this.company_growth_percentage = ko.observable(0);
		this.end_date_timeout = null;
		this.start_date_timeout = null;

		this.date_start.subscribe((newValue) => {
			if (!newValue) return;

			// Clear any existing timeout
			if (this.start_date_timeout)
				clearTimeout(this.start_date_timeout);

			this.start_date_timeout = setTimeout(() => {
				let sd = moment(newValue, "YYYY-MM-DD", true);
				if (!sd.isValid()) return;

				// Update end date to last day of start date month
				let month_end = moment(sd).endOf('month').format('YYYY-MM-DD');
				this.date_end(month_end);

				this.page.updateData();
			}, 500);
		});

		this.date_end.subscribe((newValue) => {
			if (!newValue) return;

			// Clear any existing timeout
			if (this.end_date_timeout)
				clearTimeout(this.end_date_timeout);

			// Set new timeout to wait for user to finish typing
			this.end_date_timeout = setTimeout(() => {
				let ed = moment(newValue, "YYYY-MM-DD", true);
				if (!ed.isValid()) return;

				if (newValue.length === 10)
				{
					let sd = moment(this.date_start(), "YYYY-MM-DD", true);
					if (sd.isValid() && ed.isBefore(sd))
					{
						Grape.alerts.alert({ type: 'error', title: tr('Invalid Date Range'), message: tr('End date cannot be before start date') });
						return;
					}
					this.page.updateData();
				}
			}, 1000);
		});
	}
}

class ReportDepartmentGrowthPage
{
	constructor (bindings)
	{
		this.bindings = bindings;
		this.viewModel = new ReportDepartmentGrowthViewModel(this);
		this.chart;
	}

	async init()
	{
		// check access to page
		if (await Utils.redirectOnAccessDenied('DepartmentGrowthReport'))
			return;

		document.title = tr('Department Growth Report');
		window.current_page_title(tr('Department Growth Report'));

		this.setupGraph();
	}

	async updateData()
	{
		if (
			this.viewModel.date_start() != '' &&
			this.viewModel.date_start() != undefined &&
			this.viewModel.date_end() != '' &&
			this.viewModel.date_end() != undefined
		)
		{
			let data = {
				date_start: this.viewModel.date_start(),
				date_end: this.viewModel.date_end()
			};

			this.viewModel.loader(true);

			let res = await Grape.fetches.postJSON('/report_graphs/resign_vs_employed', data);
			
			if (res)
			{
				this.buildGraph(res);
				this.viewModel.loader(false);
			}
		}
	}

	
	setupGraph()
	{
		this.chart = c3.generate({
			size: {
				height: 400
			},
			data: {
				x: 'x',
				columns: [
					/* ['x', 'Platsoft', 'Skinchem', 'Maths', 'IG' , 'QC' , 'Platlife' ],
					['employed', 30, 200, 100, 400, 150, 250],
					['resignations', 130, 100, 140, 200, 150, 50] */
				],
				colors: {
					'employed': '#31859D',
					'resignations': '#FF0000',
					'growth': '#FFF000'
				},
				type: 'bar'
			},
			tooltip: {
				contents: function (d, defaultTitleFormat, defaultValueFormat, color) {
					// Sort the data to ensure consistent order
					let sorted_data = d.sort((a, b) => {
						if (a.id === 'employed') return -1;
						if (b.id === 'employed') return 1;
						return 0;
					});
					
					let html = '<table class="c3-tooltip">';
					html += '<tr><th colspan="2">' + d[0].x + '</th></tr>';
					
					sorted_data.forEach(function(item) {
						html += '<tr class="c3-tooltip-name-' + item.id + '">';
						html += '<td class="name"><span style="background-color:' + color(item.id) + '"></span>' + item.id + '</td>';
						html += '<td class="value">' + item.value + '</td>';
						html += '</tr>';
					});
					
					html += '</table>';
					return html;
				}
			},
			transition: {
				duration: 1000
			},
			legend: {
				show: false
			},
			bar: {
				width: {
					ratio: 0.7 // this makes bar width 50% of length between ticks
				}
			},
			axis: {
				x: {
					type: 'category' // this needed to load string
				}
			}
		});
	}

	buildGraph(res)
	{
		if (res != null)
		{
			// reset
			this.viewModel.total_employed_in_company(0);
			this.viewModel.total_resigned_in_company(0);
			this.viewModel.company_growth_percentage(0);

			let labelArray = ['x'];
			let dataArrayEmployed = ['employed'];
			let dataArrayResigned = ['resignations'];

			let total_employed = 0;
			let total_resigned = 0;
			let total_before_start_date = 0; // this is the total number of people that was/is employed before start date (active employees)

			for (let a = 0; a < res.length; a++)
			{
				if (res[a].employed > 0 || res[a].resignations > 0)
				{
					let people = res[a].employed_before + res[a].employed + res[a].resignations;
					let growth = (((res[a].employed - res[a].resignations) / people) * 100).toFixed(2);
					labelArray.push(res[a].department + ' ['+tr('Growth')+' ' + growth + '%]');
					dataArrayEmployed.push(res[a].employed);
					dataArrayResigned.push(res[a].resignations);
				}

				total_employed += res[a].employed;
				total_resigned += res[a].resignations;
				total_before_start_date += res[a].employed_before;
			}

			this.viewModel.total_employed_in_company(total_employed);
			this.viewModel.total_resigned_in_company(total_resigned);

			let total_people = total_before_start_date + total_employed + total_resigned; //
			let growth = (((total_employed - total_resigned) / total_people) * 100).toFixed(2) + ' %';
			this.viewModel.company_growth_percentage(growth);

			this.chart.unload(); // clear chart

			setTimeout(() => {
				this.chart.load({
					columns: [
						labelArray,
						dataArrayEmployed,
						dataArrayResigned ]
				});
			}, 1100);
		}
		else
		{
			this.chart.unload();
			this.viewModel.total_leave_in_company(0);
			this.viewModel.department_with_most_leave('None');
			this.viewModel.department_leave_total(0);
		}
	}

	show_report_help()
	{
		Grape.dialog.open('DepartmentGrowthReportHelp', { employee_id: this.bindings.id }, {});
	}
}

export default {
	route: '[/]report/report_department_growth',
	page_class: ReportDepartmentGrowthPage,
	template: template,
	template_filename: 'translation/report_department_growth'
};
